import { action, observable } from "mobx";
import { injectable } from "inversify";
import { IUser } from "csd.phoenix.models/User";
import { nullable } from "../../utils/objectUtils";

export const iid_authRootStore = Symbol("Auth Root Store");

export interface IAuthRootStore {
  user: nullable<IUser>;
  setUser(user: nullable<IUser>): void;
}

@injectable()
export class AuthRootStore implements IAuthRootStore {
  @observable.ref user: nullable<IUser> = null;

  @action
  setUser(user: nullable<IUser>) {
    this.user = user;
  }
}
